<template>
  <div class="page__main--640 spacing">
    <h1 class="m-b-m">Spacing</h1>
    <p class="lead m-b-xl">Measurements for margins and padding in layout, typography, and components.</p>
    <p class="m-b-xl">Our spacing scale is calculated on the base of 16 pixels. For example: 2 rem is calculated as 16 pixels * 2 = 32 pixels.</p>
    <section class="spacing__list">
      <article class="content-block spacing__item" v-for="space in showSpacing" :key="space.key">
        <div class="spacing__item__inner">
          <div class="spacing__item__inner__values">
            <strong class="key">{{`${mapName(space.key)}`}}</strong>
            <span class="val">{{space.value}}</span>
          </div>
          <div class="spacing__item__inner__example" :style="{width: space.value}"></div>
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import tokens from '../../../node_modules/fds-core/dist/fds-core/globals/style/export.scss'

export default {
  name: 'spacing',
  computed: {
    showSpacing () {
      const spacingMap = []
      for (const prop in tokens) {
        if (prop.split('-')[0] === 'gutter') {
          spacingMap.push({
            key: prop.split('-').slice(1, 2).join(''),
            value: tokens[prop]
          })
        }
      }
      return spacingMap
    }
  },
  methods: {
    mapName (key) {
      let newKeyName = key
      if (key.includes('xx')) {
        const count = key.split('x')
        newKeyName = `${count.length - 1}x${count[count.length - 1]}`
      }
      return newKeyName === 'none' ? 'None' : newKeyName.toUpperCase()
    }
  }
}
</script>

<style lang="scss">
.spacing {
  & .content-block {
    padding: set-gutter('l');
  }
  &__list {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: set-gutter('xl');
    margin-bottom: set-gutter('l');
    @media all and (min-width: set-bp('xs')) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media all and (min-width: set-bp('s')) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  &__item {
    margin-bottom: 0;
    &__inner {
      display: flex;
      width: 100%;
      &__values {
        display: flex;
        flex-direction: column;
        .key {
          margin-right: set-gutter('s');
        }
        .val {
          font-size: set-size('m');
          font-weight: normal;
        }
      }
      &__example {
        margin-left: auto;
        height: 100%;
        background-color: set-color('blue', 500);
        border-radius: 2px;
      }
    }
  }
}
</style>
